import { GameResultCompletedItem } from '@orientaction/types';
import { apiServiceNative } from '../../../../utils/fetchNative';

export type CompletedGameResult = {
  idResult: number;
  idGame: number;
  title: string;
  createdAt: string;
};

const unwrapCompletedResults = (payload: unknown): GameResultCompletedItem[] => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray((payload as { data?: unknown })?.data)) {
    return (payload as { data: GameResultCompletedItem[] }).data;
  }

  return [];
};

export const fetchCompletedGameResults = async (): Promise<CompletedGameResult[]> => {
  const results = unwrapCompletedResults(
    await apiServiceNative.get('/api/game-result-completed').catch(() => []),
  );

  return results
    .filter(item => item.status === 'completed' && item.idResult && item.idGame)
    .map(item => ({
      idResult: item.idResult,
      idGame: item.idGame,
      title: item.gameTitle || '',
      createdAt: item.completedAt || item.startedAt || '',
    }))
    .filter(item => item.title.trim())
    .sort(
      (left, right) => new Date(right.createdAt).valueOf() - new Date(left.createdAt).valueOf(),
    );
};
